import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页", end: true },
  { to: "/category", label: "影视分类", end: false },
  { to: "/favorites", label: "我的收藏", end: false },
  { to: "/about", label: "关于我们", end: false },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-6 lg:px-10">
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="芒果视频首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-tv-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            芒果<span className="text-primary-500">视频</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 md:ml-6">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-500/15 text-primary-400"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="ml-auto hidden md:flex w-full max-w-xs items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 focus-within:border-primary-500"
        >
          <i className="ri-search-line text-base text-foreground-500"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            type="text"
            placeholder="搜索影视剧、综艺…"
            className="w-full bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none"
          />
        </form>

        <Link
          to="/search"
          aria-label="搜索"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-700 md:hidden"
        >
          <i className="ri-search-line text-lg"></i>
        </Link>
      </div>
    </header>
  );
}